import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import apiCall from "../../../components/Api";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import MainconternLayout from "../../../components/Layout/MainconternLayout";
import BackBtn from "../../../components/Common/backBtn";
import InputRadioField from "../../../components/Common/inputRadioField";
import InputTextField from "../../../components/Common/inputTextField";
import SucessModal from "../../../components/Modal/SucessModal";
import { ProductBreadcrumbsList } from "../Const";

const ProductTypeForm = ({ edit = false }) => {
  const { id } = useParams();

  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useForm();

  const [success, setSuccess] = useState(false);

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}product-type/get/${id}`)
      .then((response) => {
        setValue("product_type_name", response.data.product_type_name);
        setValue("active", response.data.active);
        trigger();
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    edit && getMenuData();
  }, [edit]);

  const onSubmit = async (fields) => {
    if (edit) {
      const result = await apiCall(
        `product-type/update/${id}`,
        "PATCH",
        fields,
      );
      if (result.data?._id) {
        setSuccess(true);
      }
    } else {
      const result = await apiCall(`product-type/create`, "POST", fields);
      if (result.data?._id) {
        setSuccess(true);
      }
    }
  };

  return (
    <>
      <MainconternLayout
        header={
          <>
            <div className="d-flex flex-column pb-2 flex-wrap justify-content-start gap-4">
              <Breadcrumbs
                className="healthsyMasterBreadCrumbs"
                breadcrumbsList={ProductBreadcrumbsList("", edit)}
              />
              <BackBtn navigatePath="/healthsy-services/order-medicines/masters/product-type" />
            </div>
          </>
        }
        footer={<></>}
      >
        <div className="healtharticle-container healthsyContainer">
          <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
            <div className="row car-dep-form">
              <div className="col-6">
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="Product Type Name"
                  errorText="Please enter the Product Type Name"
                  name="product_type_name"
                  placeholder="Type here..."
                />
              </div>
              <div className="col-6">
                <InputRadioField
                  register={register}
                  errors={errors}
                  setValue={setValue}
                  watch={watch}
                  labelName="Status"
                />
              </div>
            </div>
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </MainconternLayout>
      {success && (
        <SucessModal
          page={"/healthsy-services/order-medicines/masters/product-type"}
          name="new ProductType"
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );

  // return (
  //   <>
  //     <Breadcrumbs
  //       className="healthsyMasterBreadCrumbs"
  //       breadcrumbsList={breadcrumbsList}
  //     />
  //     <BackBtn navigatePath="/healthsy-services/order-medicines/masters/product-type" />
  //     <div className="healtharticle mt-5">
  //       <div className="pt-3 ms-3">
  //         {/* <Breadcrumbs
  //                       breadcrumbText="Healthsy Services"
  //                       breadcrumbLink="/healthsy-services/order-medicines/masters/unit"
  //                       nestedText="Order Medicines"
  //                       nestedLink=""
  //                       nestedText2="Master"
  //                       nestedLink2=""
  //                       nestedText3="Manufacturer List"
  //                       nestedLink3=""
  //                       nestedText4={edit ? "Edit Product Type" : "Add Product Type"}
  //                       nestedLink4=""
  //                   /> */}
  //       </div>
  //       <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
  //         <div className="row car-dep-form">
  //           <div className="col-5">
  //             <InputTextField
  //               register={register}
  //               errors={errors}
  //               labelName="Product Type Name"
  //               errorText="Please enter the Product Type Name"
  //               name="product_type_name"
  //               placeholder="Type here..."
  //             />
  //           </div>
  //           <div className="col-3">
  //             <InputRadioField
  //               register={register}
  //               errors={errors}
  //               setValue={setValue}
  //               watch={watch}
  //               labelName="Status"
  //             />
  //           </div>
  //         </div>
  //         <div className="car-dep-form-button">
  //           <button type="submit" style={{ marginTop: "5%" ,border:"none"}}> }}>
  //             SUBMIT
  //           </button>
  //         </div>
  //       </form>
  //     </div>
  //     {/* </Home> */}
  //     {success && (
  //       <SucessModal
  //         page={"/healthsy-services/order-medicines/masters/product-type"}
  //         name="new Product Type"
  //         post={edit ? "updated" : "added"}
  //       />
  //     )}
  //   </>
  // );
};

export default ProductTypeForm;
